import React from 'react';
import {
  View,
  StyleSheet,
  StyleProp,
  TextStyle,
  ViewStyle,
} from 'react-native';
import { Text, ProgressBar as DefaultProgressBar } from 'exoflex';
import { AnimatedCircularProgress } from 'react-native-circular-progress';

import { PROGRESS_BAR } from '../constants/colors';

type Props = {
  type: 'default' | 'circular';
  progress: number;
  width?: number;
  indicatorHeight?: number;
  textStyle?: StyleProp<TextStyle>;
  containerStyle?: StyleProp<ViewStyle>;
  backgroundColor?: string;
  indicatorColor?: string;
};

function ProgressBar(props: Props) {
  let {
    type,
    progress,
    width = 152,
    indicatorHeight = 10,
    backgroundColor = PROGRESS_BAR.background,
    indicatorColor = PROGRESS_BAR.indicator,
    textStyle,
    containerStyle,
  } = props;

  return type === 'default' ? (
    <View style={[styles.container, containerStyle]}>
      <Text style={[styles.startText, textStyle]}>{`${progress}%`}</Text>
      <DefaultProgressBar
        progress={progress / 100}
        style={{
          flex: 1,
          backgroundColor,
          height: indicatorHeight,
        }}
        color={indicatorColor}
      />
      <Text style={[styles.endText, textStyle]}>100%</Text>
    </View>
  ) : (
    <AnimatedCircularProgress
      rotation={0}
      size={width}
      width={indicatorHeight}
      fill={progress}
      tintColor={indicatorColor}
      backgroundColor={backgroundColor}
      lineCap="round"
      style={containerStyle}
    >
      {(fill: number) => (
        <Text style={[styles.insideText, textStyle]}>
          {`${Math.round(fill)}%`}
        </Text>
      )}
    </AnimatedCircularProgress>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  startText: {
    marginRight: 12,
    fontSize: 14,
  },
  endText: {
    marginLeft: 12,
    fontSize: 14,
  },
  insideText: {
    fontSize: 24,
  },
});

export default ProgressBar;
